// frontend/src/components/common/UserAvatar.js
import React, { useState } from "react";

function getInitials(name) {
  if (!name) return "U";
  return String(name)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase())
    .join("");
}

/**
 * size: "sm" | "md" | "lg"
 * Fallback: initials
 */
export default function UserAvatar({ name, src, size = "md", className = "" }) {
  const [errored, setErrored] = useState(false);
  const showImage = src && !errored;

  return (
    <span className={`user-avatar user-avatar-${size} ${className}`}>
      {showImage ? (
        <img
          src={src}
          alt={name || "User"}
          onError={() => setErrored(true)}
        />
      ) : (
        getInitials(name)
      )}
    </span>
  );
}